import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from '@mui/material/styles';
import { persistor, store } from './store/store';
import { RouterProvider } from 'react-router';
import { createRouter } from './router';
import { theme } from './theme/theme';

import 'styles/main.scss';

const App: React.FC = () => {
  const router = React.useMemo(() => createRouter(), []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
